import * as React from "react";
const ToggleOn = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 10 8", fill: "currentColor", width: size || "10", height: size || "8", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.8 5 1.2 2.5 0 3.7 3.8 7.5 10 1.2 8.8 0z" }));
ToggleOn.displayName = "ToggleOn";
var ToggleOn_default = ToggleOn;
export {
  ToggleOn_default as default
};
